import React from "react";
import { Container, Row, Col, Image, Card } from "react-bootstrap";
import { BiStreetView } from "react-icons/bi";
import { IoSchoolSharp } from "react-icons/io5";
import { GiTeacher } from "react-icons/gi";
import { RiParentFill } from "react-icons/ri";
import ImageStudy from "../../assets/images/online1.svg";

const ToolDescription = () => {
  return (
    <div>
      <div className="section_padding ">
        <Container>
          <h2 className="section-heading text-center">
            The Best Tool To Manage Schools
          </h2>
          <Row className="align-items-center">
            <Col md={4} className="text-center">
              <Image src={ImageStudy} className="img-fluid text-center" />
            </Col>
            <Col md={8}>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                maximus eu erat ac iaculis. Phasellus vel magna tincidunt,
                viverra nunc nec, tincidunt felis. Lorem ipsum dolor sit amet,
                consectetur adipiscing elit. Etiam maximus eu erat ac iaculis.
                Phasellus vel magna tincidunt, viverra nunc nec, tincidunt felis
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="section_padding services-cards">
        <Container>
          <Row>
            <Col md={3} sm={12}>
              <Card>
                <Card.Body>
                  <BiStreetView className="service-icon" />
                  <Card.Title>Overview</Card.Title>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                  maximus eu erat ac iaculis. Phasellus vel magna tincidunt,
                  viverra nunc nec, tincidunt felis.
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={12}>
              <Card>
                <Card.Body>
                  <IoSchoolSharp className="service-icon" />
                  <Card.Title>Student Center</Card.Title>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                  maximus eu erat ac iaculis. Phasellus vel magna tincidunt,
                  viverra nunc nec, tincidunt felis.
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={12}>
              <Card>
                <Card.Body>
                  <GiTeacher className="service-icon" />
                  <Card.Title>Teacher Center</Card.Title>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                  maximus eu erat ac iaculis. Phasellus vel magna tincidunt,
                  viverra nunc nec, tincidunt felis.
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} sm={12}>
              <Card>
                <Card.Body>
                  <RiParentFill className="service-icon" />
                  <Card.Title>Guardian Center</Card.Title>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                  maximus eu erat ac iaculis. Phasellus vel magna tincidunt,
                  viverra nunc nec, tincidunt felis.
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default ToolDescription;
